module.exports = __webpack_public_path__ + "3d680425ae05225f220eb4c07db40893.svg";